import { render } from "./purchase-order.vue?vue&type=template&id=5bdb0bcb&scoped=true"
import script from "./purchase-order.vue?vue&type=script&lang=js"
export * from "./purchase-order.vue?vue&type=script&lang=js"

import "./purchase-order.vue?vue&type=style&index=0&id=5bdb0bcb&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bdb0bcb"]])

export default __exports__